import type { InterventionAddButtonProps } from "./intervention-add-button.type";

import InterventionCreate from "@/features/Interventions/Create";
import ModelAddButton from "@/modules/model-add-button";

const InterventionAddButton = ({
  ancestors = [],
  max_days_delay,
  recommendation,
  redirectToModel,
  ...options
}: InterventionAddButtonProps) => {
  return (
    <ModelAddButton
      model="intervention"
      component={
        <InterventionCreate
          ancestors={ancestors}
          max_days_delay={max_days_delay}
          recommendation={recommendation}
          redirectToModel={redirectToModel}
        />
      }
      {...options}
    />
  );
};

export default InterventionAddButton;
